import { FC } from 'react'

import styled from 'styled-components'

import { RateStars } from '../RateStars'

const StyledRateInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`
export const StyledRateStars = styled(RateStars)`
  .rate-info-star {
    svg {
      path {
        stroke: ${({ theme }) => theme.color.darkGrey};
      }
    }
  }
`

export type RateInfoProps = {
  productionValue?: number
  vocalValue?: number
  melodyValue?: number
}

export const RateInfo: FC<RateInfoProps> = ({
  productionValue = 0,
  vocalValue = 0,
  melodyValue = 0,
}) => (
  <StyledRateInfo>
    <StyledRateStars count={1} value={0} disabled prefixCls='rate-info' />
    <span>Production: {Number(productionValue)}/5</span>
    {Boolean(vocalValue) && <span>Vocal: {Number(vocalValue)}/5</span>}
    <span>Melody: {Number(melodyValue)}/5</span>
  </StyledRateInfo>
)
